import { useQuery } from '@tanstack/react-query'
import { zetApi } from '@zet/network'

import { isIOS, isWebView } from '../utils'

interface IDecodedToken {
  actionData: {
    phoneNumber: string
    customerId?: number
    jfsConsent: object
    hash?: string
  }
  action?: any
}

export const useGetDecryptToken = (token: string) => {
  return useQuery<IDecodedToken>(
    ['jfsDecryptToken', token],
    () => getDescryptJwtToken(token),
    {
      enabled: !!token,
      cacheTime: 0,
      staleTime: 0,
      retry: false,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    },
  )
}

export const getDescryptJwtToken = async (token: string) => {
  const { data } = await zetApi.post(
    `jfs/decryptToken?jwtToken=${token}`,
    {},
    {
      headers: {
        ...zetApi.defaults.headers.common,
        appOs: !isWebView() ? 'web' : isIOS() ? 'ios' : 'android',
      },
    },
  )
  if (data?.data) {
    return data.data
  } else {
    return data?.error
  }
}
